<template>
  <section ref="topicArticleSlideRef" class="topic-article-slide">
    <div class="asc-desc-group">
      <div
        class="asc-btn"
        :class="{ 'asc-desc-active': articleSort === 'desc' }"
        @click="articleSort = 'desc'"
      >
        <div class="desc-btn-icon"></div>
        倒序
      </div>
      <div
        class="desc-btn"
        :class="{ 'asc-desc-active': articleSort === 'asc' }"
        @click="articleSort = 'asc'"
      >
        <div class="asc-btn-icon"></div>
        正序
      </div>
    </div>
    <topic-article
      v-for="article in newsListSort"
      :key="article.id"
      :article="article"
    >
    </topic-article>
    <bottom-tips></bottom-tips>
  </section>
</template>

<script setup lang="ts">
defineOptions({
  name: 'TopicArticleSlide',
});
const props = defineProps<{ newsList: Topic.Article[] }>();

const articleSort = ref<'asc' | 'desc'>('desc');

const newsListSort = computed(() => {
  const tempList = [...props.newsList];
  if (articleSort.value === 'desc') {
    return tempList;
  }
  tempList.reverse();
  return tempList;
});
</script>

<style lang="scss" scoped>
.topic-article-slide {
  position: relative;
  background: var(--article-list-background);
  background-repeat: no-repeat;
  background-size: 100%;
}
</style>
